"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailOrCallText = exports.emailOrCallHome = void 0;

var _isMobile = _interopRequireDefault(require("../utils/isMobile"));

var emailOrCallHome = function emailOrCallHome() {
  if ((0, _isMobile["default"])()) {
    // Tyler's cell phone!
    window.location.href = 'tel:6172376914';
  } else {
    window.location.href = 'mailto:sales@gofisherman.com';
  }
};

exports.emailOrCallHome = emailOrCallHome;

var getEmailOrCallText = function getEmailOrCallText() {
  return (0, _isMobile["default"])() ? 'Call Sales' : 'Email Sales';
};

exports.getEmailOrCallText = getEmailOrCallText;